import classNames from 'classnames'
import { observer } from 'mobx-react'
import { useLocation } from 'react-router'
import './index.scss'

const Directions = observer(
  ({ content, classname }: { content: any; classname: string }) => {
    const { pathname } = useLocation()
    return (
      <section
        className={classNames(
          'things-directs',
          classname,
          // pathname.includes('business') && 'dark-theme',
        )}
      >
        <div className="things-col__subtitle">{content.title}</div>
        <ul className="things-directs__list">
          {content.list.map((li: any, i: number) => (
            <li
              className="things-directs__item"
              key={i}
              dangerouslySetInnerHTML={{ __html: li }}
            ></li>
          ))}
        </ul>
      </section>
    )
  },
)

export default Directions
